import React, { Component } from "react";
import { RouteComponentProps } from "react-router";
import Datatable from "../../Constants/Datatable";
import { PENCIL } from "../../Constants/SrcImages";
import { COLUMNS_PLANS } from "../../Constants/DatatableColumns";
import { Row, Col, Container, Button, Label } from "reactstrap";
import { AdminHandlerPlans } from "./../../Constants/Modal";
import {validateTokenStorage} from './../../Constants/Util';
import { getPlans, getCycles, postPlans, putPlans } from "../../Constants/Services";
import { IPlans, ICycles } from "./../../Constants/Interfaces";
import ClipLoader from "react-spinners/ClipLoader";
import { css } from "@emotion/core";

const override = css`
  margin: 0 auto;
  position: relative;
  top: 10px;
  right: 10px;
`;

interface IPlansState {
  dataPlan: IPlans[];
  formPlan: IPlans;
  dataCycles: ICycles[];
  formCycle: ICycles;
  isOpenModalEditPlan: boolean;
  isOpenModalAddPlan: boolean;
  msg_error: string;
  loading: boolean;
}

class Plans extends Component<RouteComponentProps<{}>, IPlansState> {
  constructor(props: any) {
    super(props);
    this.state = {
      dataPlan: [],
      dataCycles: [],
      formPlan: {
        pl_id: "",
        pl_desc: "",
        cy_id: "",
        cy_desc: "",
      },
      formCycle: {
        cy_id: "",
        cy_desc: "",
      },
      isOpenModalEditPlan: false,
      isOpenModalAddPlan: false,
      msg_error: "",
      loading: false,
    };

    this.fetchPlan = this.fetchPlan.bind(this);
    this.fetCycles = this.fetCycles.bind(this);
    this.handlerPutPlans = this.handlerPutPlans.bind(this);
    this.handlerPostPlans = this.handlerPostPlans.bind(this);
    this.onChangePlans = this.onChangePlans.bind(this);
    this.setCycle = this.setCycle.bind(this);
    this.handleModalEditPlan = this.handleModalEditPlan.bind(this);
    this.handleModalAddPlan = this.handleModalAddPlan.bind(this);
    this.rechargeData = this.rechargeData.bind(this);
  }

  async fetchPlan() {
    const response = await getPlans();
    this.setState({
      dataPlan: response,
      loading: false,
    });
  }

  async fetCycles() {
    const response = await getCycles();
    this.setState({
      dataCycles: response,
    });
  }
  componentDidMount() {
    if(validateTokenStorage()){
      this.context.quitToken();
    }
    this.fetchPlan();
    this.fetCycles();
  }

  handlerPostPlans() {
    const props = this.state.formPlan;
    const propsCycle = this.state.formCycle;
    const body = {
      pl_cycle: propsCycle.cy_id,
      pl_desc: props.pl_desc,
    };
    if (propsCycle.cy_id.length > 0 && props.pl_desc.length>0) {
      postPlans(body);
      this.setState({ isOpenModalAddPlan: false, msg_error: "" });
      setTimeout(() => {
        this.fetchPlan();
      }, 1000);
    } else {
      this.setState({ msg_error: "Algunos campos estan vacios" });
    }
  }

  handlerPutPlans() {
    const props = this.state.formPlan;
    const propsCycle = this.state.formCycle;
    const body = {
      pl_cycle: propsCycle.cy_id,
      pl_id: props.pl_id,
      pl_desc: props.pl_desc,
    };

    if (props.pl_desc.length>0) {
      putPlans(body);
      this.setState({ isOpenModalEditPlan: false });
  
      setTimeout(() => {
        this.fetchPlan();
      }, 1000);
    }
    else{
      this.setState({ msg_error: "Algunos campos estan vacios" });
    }

  }

  onChangePlans(e: any) {
    this.setState({
      formPlan: {
        ...this.state.formPlan,
        [e.target.name]: e.target.value,
      },
      msg_error:""
    });
  }

  handleModalEditPlan(row: IPlans) {
    this.setState((prevState) => ({
      isOpenModalEditPlan: !prevState.isOpenModalEditPlan,
      formPlan: row,
      formCycle: {
        cy_id: row.cy_id,
        cy_desc: row.cy_desc,
      },
      msg_error:""
    }));
  }

  handleModalAddPlan() {
    this.setState((prevState) => ({
      isOpenModalAddPlan: !prevState.isOpenModalAddPlan,
      formPlan: {
        pl_id: "",
        pl_desc: "",
        cy_id: "",
        cy_desc: "",
      },
      formCycle: {
        cy_id: "",
        cy_desc: "",
      },
      msg_error:""
    }));
  }

  setCycle = ({ cy_desc, cy_id }: ICycles) => {
    this.setState({
      formCycle: {
        ...this.state.formCycle,
        cy_id,
        cy_desc,
      },
    });
  };

  handlerEdit = (cell: any, row: IPlans) => (
    <React.Fragment>
      <Row>
        <Col xs={12} className="d-flex">
          <Label className="txt-underline" onClick={() => this.handleModalEditPlan(row)}>
            {row.pl_id}
          </Label>
          <img className="img-status img-search" onClick={() => this.handleModalEditPlan(row)} src={PENCIL} alt="" />
        </Col>
      </Row>
    </React.Fragment>
  );

  rechargeData() {
    this.setState({ loading: true });
    setTimeout(() => {
      this.fetchPlan();
    }, 1000);
  }

  render() {
    const props = this.state;
    return (
      <React.Fragment>
        {props.isOpenModalAddPlan && (
          <AdminHandlerPlans
            title="Agregar nuevo plan"
            cycles={props.dataCycles}
            dataFplans={props.formPlan}
            dataFcycle={props.formCycle}
            isOpen={props.isOpenModalAddPlan}
            toggle={this.handleModalAddPlan}
            toggleSave={this.handlerPostPlans}
            onChange={this.onChangePlans}
            setCycle={this.setCycle}
            msg_error={props.msg_error}
          />
        )}

        {props.isOpenModalEditPlan && (
          <AdminHandlerPlans
            AdminHandlerPlans="Editar plan"
            cycles={props.dataCycles}
            dataFplans={props.formPlan}
            dataFcycle={props.formCycle}
            isOpen={props.isOpenModalEditPlan}
            toggle={this.handleModalEditPlan}
            toggleSave={this.handlerPutPlans}
            onChange={this.onChangePlans}
            setCycle={this.setCycle}
            msg_error={props.msg_error}
          />
        )}

        <Container className="mt-4">
          <Row>
            <Col sm={12}>
              <Row>
                <Col sm={12} className="text-center">
                  <h3>Planes</h3>
                </Col>
                <Col sm={12} className="text-right">
                  <ClipLoader css={override} size={23} color={"#36D7B7"} loading={this.state.loading} />
                  <Button color="primary" className="mr-2" onClick={() => this.rechargeData()}>
                    Recargar
                  </Button>
                  <Button color="success" className="mr-2" onClick={() => this.handleModalAddPlan()}>
                    Agregar Nuevo
                  </Button>
                </Col>
                <Col sm={12}>
                  <Datatable
                    data={props.dataPlan}
                    columns={COLUMNS_PLANS(this.handlerEdit)}
                    keyProp="pl_id"
                    exportD={false}
                    searchs={false}
                    selectRows={false}
                    optionSelectRow={null}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

export default Plans;